export enum DateType {
  COLLECTED = "DATE_COLLECTED",
  MRO_REPORTED = "MRO_REPORTED_DATE",
  LAB_REPORTED = "LAB_REPORTED_DATE",
}

export const DateTypeLabel = new Map<DateType, string>([
  [DateType.COLLECTED, "Collected Date"],
  [DateType.MRO_REPORTED, "MRO Reported Date"],
  [DateType.LAB_REPORTED, "Lab Reported Date"],
])
